(function(){
  var el=document.getElementById('mccombo'); if(!el) return;
  var pid=el.getAttribute('data-pid'), sid=el.getAttribute('data-sid');
  // La logica canonica vive en snippets/micase-modelo.liquid (window.MCModelo).
  // Antes esta copia solo traducia el patron exacto " Pro + (" y no el signo mas en
  // cualquier otra posicion, asi que podia devolver un handle distinto al del resto de
  // las secciones para el mismo nombre.
  function mchandle(s){
    if(window.MCModelo && window.MCModelo.handle) return window.MCModelo.handle(s);
    /* respaldo: misma logica, por si el snippet no cargo. El + pasa a la palabra plus
       ANTES de limpiar; sin eso "Pro + (5G)" y "Pro (5G)" quedan identicos. */
    return String(s == null ? '' : s).toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g,'')
      .replace(/\+/g,' plus ').replace(/[^a-z0-9]+/g,'-').replace(/^-+|-+$/g,'');
  }
  function mcopt(p){var idx=-1;(p.options||[]).forEach(function(o,i){if(idx<0&&/modelo/i.test(String(o)))idx=i});if(idx<0&&p.options&&p.options.length===1)idx=0;return idx}
  function mccur(p,idx,optName){var q='input[type=radio][name="'+(window.CSS&&CSS.escape?CSS.escape(optName):optName)+'"]:checked';var r=document.querySelector(q);if(r)return r.value;var v=null,i;for(i=0;i<(p.variants||[]).length;i++){if(p.variants[i].available){v=p.variants[i];break}}v=v||(p.variants&&p.variants[0]);return v?v.options[idx]:null}
  var mode='quiz', currentHandle=null, currentName=null;
  // Orden de prioridad del complemento segun lo que la persona esta mirando.
  // Regla de negocio: contra 106 fundas solo hay 9 protectores de pantalla y 3 de camara,
  // asi que la pantalla va SIEMPRE primero cuando se mira una funda; si no, el combo
  // terminaria recomendando otra funda casi siempre. 'accesorio' NO aparece en ninguna
  // lista: se descarta antes de elegir (ver pick), no es una opcion de relleno.
  var PRIO_DEF={
    funda:['pantalla','camara','trasero','funda','otro'],
    pantalla:['funda','camara','trasero','pantalla','otro'],
    camara:['funda','pantalla','trasero','camara','otro'],
    trasero:['pantalla','funda','camara','trasero','otro'],
    accesorio:['funda','pantalla','camara','trasero','otro'],
    otro:['pantalla','camara','funda','trasero','otro']
  };
  // El orden lo edita Sebastian desde el ajuste "Orden de prioridad" del tema. Si el texto
  // esta vacio o mal escrito se usa PRIO_DEF, que es exactamente la tabla de arriba.
  function mcprio(txt){
    var out={}, ok=false;
    String(txt||'').split(/[\r\n;]+/).forEach(function(ln){
      var i=ln.indexOf(':'); if(i<0) return;
      var k=ln.slice(0,i).trim().toLowerCase(); if(!k) return;
      var v=ln.slice(i+1).split(',').map(function(s){return s.trim().toLowerCase()}).filter(function(s){return s});
      if(!v.length) return;
      out[k]=v; ok=true;
    });
    return ok?out:null;
  }
  var PRIO=mcprio(el.getAttribute('data-prio'))||PRIO_DEF;
  var MAX=parseInt(el.getAttribute('data-max'),10); if(!(MAX>0)) MAX=3;
  var ANCLADOS=(el.getAttribute('data-anclados')||'').split(',').map(function(s){return s.trim()}).filter(function(s){return s});
  var LBL={pantalla:el.getAttribute('data-l-pantalla'),camara:el.getAttribute('data-l-camara'),
    trasero:el.getAttribute('data-l-trasero'),funda:el.getAttribute('data-l-funda')};
  var LBL_OTRO=el.getAttribute('data-l-otro');
  var EXTRA_MAX=parseInt(el.getAttribute('data-extra-max'),10); if(!(EXTRA_MAX>0)) EXTRA_MAX=6;
  var EXTRA_BOTON=el.getAttribute('data-extra-boton')||'Agregar';
  var EXTRA_VER=el.getAttribute('data-extra-ver')||'Ver';
  var PREP_TU=el.getAttribute('data-prep-tu')||'de tu', PREP_PARA=el.getAttribute('data-prep-para')||'para';
  // 2026-07-28 · ENVIO GRATIS, CON LA VERDAD. Numeros reales: funda 34.900 + protector de
  // pantalla 33.900 + protector de camara 26.000 = 94.800, y el umbral es 110.000. Faltan
  // 15.200 y la persona no lo sabe. El hueco se calcula SOLO contra el subtotal real del
  // carrito (/cart.js -> items_subtotal_price, en centimos). NO se proyecta el producto
  // que se esta mirando: todavia no lo ha agregado, y sumarlo seria mentirle. Si /cart.js
  // falla no se muestra nada; nunca una cifra inventada.
  // 2026-08-18 · MATIZADO: eso vale para la BARRA, no para la FRASE. Ver envProyecta().
  var ENV_MIN=parseInt(String(el.getAttribute('data-envio-min')||'').replace(/[^0-9]/g,''),10);
  if(!(ENV_MIN>0)) ENV_MIN=0;
  var ENV_ON=(el.getAttribute('data-envio-on')==='true')&&(el.getAttribute('data-envio-mostrar')==='true')&&ENV_MIN>0;
  var ENV_META=ENV_MIN*100;
  var ENV_T_FALTA=el.getAttribute('data-envio-falta')||'';
  // 2026-08-16 · EL MENSAJE DE ARRANQUE. Con el carrito vacio faltan los 110.000
  // enteros y las tres tarjetas suman menos (34.900+26.900+34.900 = 96.700 en la ficha
  // del Business Carbono), asi que envCombo() no encuentra ninguna combinacion que
  // cruce y caia en ENV_T_FALTA: "Te faltan $110.000 para el envio gratis". Cierto y
  // desmoralizante: el producto mas caro de la tienda vale 59.900, o sea que ningun
  // pedido de un solo articulo alcanza el umbral JAMAS, y el 39,1 % de los pedidos son
  // de una unidad.
  // 2026-08-18 · ESTA VIA SE DESCARTO. Enseniar lo que queda DESPUES de agregar las tres
  // tarjetas da "te quedas a solo 12.700": cierto, pero lo que comunica es "compra cuatro
  // cosas y aun asi no tienes envio gratis". Peor que el mensaje actual. La via buena es
  // la condicional de envProyecta(). ENV_T_ARR y ENV_T_ARR1 se quedan leyendose por si
  // algun dia se retoma, pero la seccion no emite esos atributos y nadie los usa.
  var ENV_T_ARR=el.getAttribute('data-envio-arranque')||'';
  var ENV_T_ARR1=el.getAttribute('data-envio-arranque-uno')||'';
  var ENV_T_AHORA=el.getAttribute('data-envio-ahora')||'';
  var ENV_T_CASI=el.getAttribute('data-envio-casi')||'';
  // 2026-08-18 · LA FRASE CONDICIONAL. Ver el comentario largo en envProyecta().
  var ENV_T_PROY=el.getAttribute('data-envio-proy')||'';
  var ENV_T_PROY1=el.getAttribute('data-envio-proy-uno')||'';
  var ENV_PRECIOS=null;
  try{ var _pn=document.getElementById('mccombo-precios'); if(_pn) ENV_PRECIOS=JSON.parse(_pn.textContent||'{}') }catch(e){ ENV_PRECIOS=null }
  var ENV_T_OK=el.getAttribute('data-envio-logrado')||'';
  var ENV_T_INS=el.getAttribute('data-envio-insignia')||'';
  var ENV_T_BN=el.getAttribute('data-envio-b-varios')||'';
  var ENV_T_B1=el.getAttribute('data-envio-b-uno')||'';
  var ENV_T_ESP=el.getAttribute('data-envio-b-espera')||'';
  var envSub=null, envSel=null, envOcupado=false, envCartPids={};
  function envCarritoIds(c){
    var sig={}, cambio=false, k, its=(c&&c.items)||[];
    for(var i=0;i<its.length;i++){
      if(its[i]&&its[i].product_id) sig[String(its[i].product_id)]=1;
    }
    for(k in sig){ if(!envCartPids[k]){ cambio=true; break } }
    if(!cambio){ for(k in envCartPids){ if(!sig[k]){ cambio=true; break } } }
    envCartPids=sig;
    return cambio;
  }
  function cop(n){ return '$'+String(n).replace(/\B(?=(\d{3})+(?!\d))/g,'.') }
  function envFalta(){ if(!ENV_ON||envSub===null) return null; var d=ENV_META-envSub; return d>0?d:0 }
  function envPrecio(n){
    // el precio ya esta en el DOM de la tarjeta, formato COP del tema: "$34.900,00"
    var p=n.querySelector('.mccombo__p'); if(!p) return null;
    var t=(p.textContent||'').replace(/[^0-9.,]/g,'').replace(/\.(?=\d{3})/g,'').replace(/,\d{1,2}$/,'').replace(/[^0-9]/g,'');
    if(!t) return null;
    var v=parseInt(t,10); return isNaN(v)?null:v*100;
  }
  // 2026-07-28 · COMBINACION MINIMA QUE CRUZA EL UMBRAL. Antes solo se marcaba la tarjeta
  // cuyo precio cerraba el hueco POR SI SOLO, y con el carrito vacio eso no pasa nunca:
  // faltan 110.000 y los complementos valen entre 26.000 y 34.900. Resultado: ninguna
  // insignia y una linea de "te faltan 110.000" que no invitaba a nada. Como la lista
  // muestra 3 tarjetas (4 es el maximo del ajuste), se evaluan POR FUERZA BRUTA todos los
  // subconjuntos y gana el que cruza el umbral con MENOS productos; a igualdad de
  // cantidad, el de MENOR total. No se busca el carrito mas caro sino el camino mas corto
  // y mas barato hasta el envio gratis: que la persona gaste lo minimo necesario.
  // Si ni sumando todas las tarjetas se cruza el umbral, devuelve null y no se promete nada.
  // Solo entran tarjetas con formulario (variante disponible para ese modelo): las que
  // caen en el enlace "Ver" no se pueden agregar por AJAX y no forman parte de la promesa.
  // 2026-08-18 · admite un objetivo distinto al hueco real, para poder preguntar
  // "que combinacion cierra el hueco QUE QUEDA si ademas se lleva este producto".
  function envCombo(objetivo){
    var f=(typeof objetivo==='number')?objetivo:envFalta(); if(f===null||f<=0) return null;
    var list=document.getElementById('mccombo-list'); if(!list) return null;
    var c=[];
    Array.prototype.slice.call(list.children).forEach(function(n){
      var inp=n.querySelector('.mccombo__f input[name="id"]'), pr=envPrecio(n);
      if(inp&&inp.value&&pr!==null&&pr>0) c.push({n:n,id:inp.value,pr:pr});
    });
    if(!c.length||c.length>12) return null;
    var best=null, m=1<<c.length, i, j;
    for(i=1;i<m;i++){
      var sel=[], tot=0;
      for(j=0;j<c.length;j++){ if(i&(1<<j)){ sel.push(c[j]); tot+=c[j].pr } }
      if(tot<f) continue;
      if(!best||sel.length<best.items.length||(sel.length===best.items.length&&tot<best.total)){
        best={items:sel,total:tot};
      }
    }
    return best;
  }
  // Todas las tarjetas AGREGABLES de arriba y lo que suman. Mismo criterio que
  // envCombo (solo las que tienen formulario: las del enlace "Ver" no se pueden
  // agregar y no pueden formar parte de ninguna promesa) y mismo precio, leido del
  // mismo nodo del DOM. No se incluye el carril de "otros acabados": ahi el precio
  // tambien esta, pero esas tarjetas no se marcan ni entran en el calculo del combo,
  // y prometer sobre algo que no se resalta confunde mas de lo que ayuda.
  function envSuma(){
    var list=document.getElementById('mccombo-list'); if(!list) return {n:0,total:0};
    var n=0,total=0;
    Array.prototype.slice.call(list.children).forEach(function(x){
      var inp=x.querySelector('.mccombo__f input[name="id"]'), pr=envPrecio(x);
      if(inp&&inp.value&&pr!==null&&pr>0){ n++; total+=pr }
    });
    return {n:n,total:total};
  }
  // 2026-08-18 · EL PRECIO DE LO QUE SE ESTA MIRANDO.
  // El id de la variante elegida se busca entre TODOS los input[name="id"] de la pagina y
  // gana el primero que exista en el mapa de precios: el mapa solo trae las variantes de
  // este producto, asi que se valida solo y no depende del marcado de Dawn, que cambia
  // entre versiones. Devuelve 0 -y por tanto no se proyecta nada- si el producto YA esta
  // en el carrito, porque entonces su precio ya esta contado en la barra solida.
  function envProdPrecio(){
    if(!ENV_PRECIOS) return 0;
    var pid=el.getAttribute('data-pid');
    if(pid&&envCartPids[String(pid)]) return 0;
    var ins=document.querySelectorAll('input[name="id"]'), i, v;
    for(i=0;i<ins.length;i++){ v=String(ins[i].value||''); if(ENV_PRECIOS[v]>0) return ENV_PRECIOS[v] }
    return 0;
  }
  // 2026-08-18 · LA CONDICIONAL, y por que existe.
  // El comentario de arriba decia que proyectar el producto que se esta mirando "seria
  // mentirle". Es cierto para la BARRA y falso para la FRASE: ignorar la funda que la
  // persona esta a punto de comprar hace que el medidor subestime SIEMPRE lo cerca que
  // esta. Con el carrito vacio y un umbral de 110.000, las tres tarjetas suman menos y el
  // mensaje caia en "Te faltan $110.000", que es la distancia total y no invita a nada.
  // Contando el producto, en cambio, dos tarjetas suelen bastar.
  // LA GARANTIA DE VERDAD: la barra SOLIDA sigue pintando unicamente el carrito real. Lo
  // que se proyecta vive en el tramo rayado -que por diseno significa "todavia no es tuyo,
  // pero esta a un clic"- y en una frase escrita como CONDICION: "si lo llevas con dos de
  // estos". Una condicional verdadera no es una promesa falsa.
  function envProyecta(f){
    if(!ENV_T_PROY&&!ENV_T_PROY1) return null;
    var pv=envProdPrecio(); if(!(pv>0)) return null;
    var need=f-pv; if(need<=0) return null;
    var c=envCombo(need); if(!c) return null;
    return {items:c.items,total:c.total,prod:pv};
  }
  function envInsignias(combo){
    var list=document.getElementById('mccombo-list'); if(!list) return;
    var en={}; if(ENV_ON&&combo){ combo.items.forEach(function(x){ en[x.id]=1 }) }
    Array.prototype.slice.call(list.children).forEach(function(n){
      var b=n.querySelector('.mccombo__ins');
      var inp=n.querySelector('.mccombo__f input[name="id"]');
      if(!ENV_ON||!ENV_T_INS){ if(b&&b.parentNode){ b.parentNode.removeChild(b) } return }
      if(!b){
        b=document.createElement('span'); b.className='mccombo__ins';
        var pn=n.querySelector('.mccombo__p');
        if(pn&&pn.parentNode){ pn.parentNode.insertBefore(b,pn.nextSibling) } else { n.appendChild(b) }
      }
      b.textContent=ENV_T_INS;
      // Nunca se saca del DOM: se enciende o se apaga con visibility para que las
      // tres tarjetas midan igual. Ver .mccombo__ins en el CSS de arriba.
      var activa=!!(inp&&inp.value&&en[inp.value]);
      b.className='mccombo__ins'+(activa?' mccombo__ins--on':'');
      // Ademas de la capsula, se marca la TARJETA: es lo que de verdad se nota.
      n.classList.toggle('mccombo__it--env',activa);
    });
  }
  function envBoton(combo){
    var b=document.getElementById('mccombo-cta'); if(!b||envOcupado) return;
    var n=combo?combo.items.length:0;
    var txt=combo?(n===1?ENV_T_B1:ENV_T_BN):'';
    if(!ENV_ON||!combo||!txt){ b.hidden=true; b.textContent=''; return }
    b.textContent=String(txt).split('{n}').join(String(n)).split('{total}').join(cop(Math.round(combo.total/100)));
    b.disabled=false; b.hidden=false;
  }
  // Escribe "Llevas $67.900" partiendo el texto del ajuste en el marcador {tienes}
  // y metiendo la cifra en un <b>. Sin innerHTML: solo nodos de texto.
  function envTexto(nodo,plantilla,marcador,valor){
    if(!nodo) return;
    nodo.textContent='';
    var p=String(plantilla||'').split(marcador);
    nodo.appendChild(document.createTextNode(p[0]||''));
    if(p.length>1){
      var b=document.createElement('b'); b.textContent=valor; nodo.appendChild(b);
      nodo.appendChild(document.createTextNode(p.slice(1).join(marcador)));
    }
  }
  function envPinta(){
    var box=document.getElementById('mccombo-envio');
    var f=envFalta();
    envSel=envCombo();
    var envProy=(f!==null&&f>0&&!envSel)?envProyecta(f):null;
    if(box){
      if(f===null){
        box.hidden=true; box.className='mcenv';
      } else {
        var pct=ENV_META>0?Math.min(100,Math.round(envSub/ENV_META*100)):0;
        // El tramo rayado nunca pasa de la meta: prometer mas alla del 100% no
        // agrega informacion y rompe la lectura de "ya llegue".
        // Con la proyeccion el rayado incluye TAMBIEN el producto de la ficha: es
        // exactamente lo que dice la frase, y sin el la barra contradice al texto.
        var gtot=envSel?envSel.total:(envProy?(envProy.total+envProy.prod):0);
        var gp=(f>0&&gtot>0&&ENV_META>0)?Math.min(100-pct,Math.round(gtot/ENV_META*100)):0;
        var fill=document.getElementById('mcenv-fill'), ghost=document.getElementById('mcenv-ghost');
        if(fill) fill.style.width=pct+'%';
        if(ghost){ ghost.style.left=pct+'%'; ghost.style.width=gp+'%' }
        envTexto(document.getElementById('mcenv-now'),ENV_T_AHORA,'{tienes}',cop(Math.round(envSub/100)));
        var hint=document.getElementById('mcenv-hint'), t='';
        if(f<=0){ t=ENV_T_OK }
        else if(envSel&&ENV_T_CASI){ t=String(ENV_T_CASI).split('{n}').join(String(envSel.items.length)).split('{falta}').join(cop(Math.round(f/100))) }
        else if(envProy){
          var nP=envProy.items.length, tP=(nP===1&&ENV_T_PROY1)?ENV_T_PROY1:ENV_T_PROY;
          if(!tP) tP=ENV_T_PROY1;
          t=String(tP).split('{n}').join(String(nP)).split('{falta}').join(cop(Math.round(f/100)));
        }
        else { t=String(ENV_T_FALTA).split('{falta}').join(cop(Math.round(f/100))) }
        if(hint) hint.textContent=t;
        box.className='mcenv'+(f<=0?' mcenv--ok':((envSel||envProy)?' mcenv--casi':''));
        box.hidden=false;
      }
    }
    // Se marcan las tarjetas de la combinacion que la frase esta nombrando, sea la real
    // o la proyectada: sin eso el cliente lee "2 de estos" y no sabe cuales dos.
    // El BOTON de "agregar todo" sigue colgando solo de la combinacion REAL: ese boton
    // promete envio gratis al pulsarlo, y bajo proyeccion haria falta ademas el producto.
    envInsignias(envSel||envProy);
    envBoton(envSel);
  }
  function envLee(cb){
    if(!ENV_ON) return;
    fetch('/cart.js',{credentials:'same-origin',headers:{'Accept':'application/json'}})
      .then(function(r){ if(!r.ok) throw 0; return r.json() })
      .then(function(c){
        var v=(c&&typeof c.items_subtotal_price==='number')?c.items_subtotal_price:null;
        if(v===null) throw 0;
        var cambio=envCarritoIds(c);
        envSub=v;
        if(cambio&&currentHandle&&!el.hidden){ load(currentName,currentHandle,true) }
        else { envPinta() }
        if(cb) cb(c);
      })
      .catch(function(){ envSub=null; envPinta(); if(cb) cb(null) });
  }
  // 2026-08-10 · EL CAJON NO SE REFRESCABA AL AGREGAR EL COMBO.
  // CAUSA: esta funcion era una copia del codigo del tema Glozin: pedia e inyectaba la
  // seccion 'minicart-form' y abria <cart-notification>. En este tema NO existe ni esa
  // seccion ni ese id: el cajon es <cart-drawer> de Dawn, contenedor #CartDrawer. La
  // peticion devolvia una seccion vacia, la inyeccion no ocurria nunca y el cajon seguia
  // mostrando el carrito viejo aunque el producto si entrara.
  // ARREGLO: se pide e inyecta la seccion 'cart-drawer' dentro de #CartDrawer, se
  // actualiza la clase is-empty del <cart-drawer> (si no, el boton de pagar queda
  // deshabilitado con productos dentro), se reengancha el cierre por el fondo
  // (#CartDrawer-Overlay, que se pierde al reemplazar el interior, igual que hace
  // renderContents() de Dawn) y se abre con dr.open(). El contador y el total de la
  // cabecera se siguen actualizando con el carrito real, como antes.
  function envMini(st,c){
    try{
      var dr=document.querySelector('cart-drawer');
      var host=document.getElementById('CartDrawer');
      var html=st&&st.sections&&st.sections['cart-drawer'];
      if(host&&html){
        var src=new DOMParser().parseFromString(html,'text/html').getElementById('CartDrawer');
        if(src){
          host.innerHTML=src.innerHTML;
          if(dr){
            dr.classList.toggle('is-empty',!!host.querySelector('.drawer__inner-empty'));
            var capa=host.querySelector('#CartDrawer-Overlay');
            if(capa&&typeof dr.close==='function') capa.addEventListener('click',dr.close.bind(dr));
          }
        }
      }
      if(c&&typeof c.item_count==='number'){
        Array.prototype.slice.call(document.querySelectorAll('.cart-count')).forEach(function(x){
          x.innerHTML=x.classList.contains('cart-count-drawer')?('('+c.item_count+')'):(c.item_count>100?'~':c.item_count);
        });
        var ht=document.querySelector('header-total-price');
        if(ht&&typeof ht.updateTotal==='function') ht.updateTotal(c);
        var fb=document.querySelector('free-ship-progress-bar');
        if(fb&&typeof fb.init==='function') fb.init(c.items_subtotal_price);
      }
      if(typeof BlsLazyloadImg!=='undefined'&&BlsLazyloadImg&&BlsLazyloadImg.init) BlsLazyloadImg.init();
      if(dr&&typeof dr.open==='function') dr.open();
    }catch(e){ console.warn('[MIcase] micase-combo: fallo al refrescar el cajon del carrito despues de agregar el combo', e); }
  }
  // Agrega DE UNA SOLA VEZ toda la combinacion minima (POST /cart/add.js con items[]).
  // Mientras envia, el boton queda deshabilitado con el texto de espera. Si el POST falla
  // el boton vuelve exactamente como estaba y no se muestra ningun mensaje falso: nunca se
  // dice "listo" sin que el carrito lo confirme.
  function envAgrega(){
    var b=document.getElementById('mccombo-cta');
    if(!b||envOcupado||!envSel||!envSel.items.length) return;
    var prev=b.textContent;
    var body={items:envSel.items.map(function(x){ return {id:x.id,quantity:1} }),sections:'cart-drawer',sections_url:window.location.pathname};
    envOcupado=true; b.disabled=true; if(ENV_T_ESP) b.textContent=ENV_T_ESP;
    fetch('/cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)})
      .then(function(r){ if(!r.ok) throw 0; return r.json() })
      .then(function(st){
        envOcupado=false; b.disabled=false; b.textContent=prev;
        envLee(function(c){ envMini(st,c) });
      })
      .catch(function(){ envOcupado=false; b.disabled=false; b.textContent=prev });
  }
  function pick(arr,cur,catsCarrito){
    // 2026-07-28 · Los 'cat:accesorio' (correas de MI Band, estuches de audifonos,
    // repuestos) NO complementan la compra de una funda de celular y nunca deben salir
    // en el combo. Se descartan del conjunto candidato ANTES de elegir: si solo se
    // dejaran al final de la tabla de prioridad, el relleno de huecos los acabaria
    // metiendo igual.
    arr=arr.filter(function(n){ return (n.getAttribute('data-cat')||'otro')!=='accesorio' });
    var rank=PRIO[cur]||PRIO.otro||PRIO_DEF.otro, out=[], used={}, catUsada={};
    // 2026-08-19 (2) · LO QUE YA ESTA EN EL CARRITO TAMBIEN CIERRA SU CATEGORIA.
    // Sebastian, viendolo en el movil: "si yo agrego un protector de pantalla, me
    // recomienda otro protector de pantalla de una, entonces no estaria funcionando bien
    // el sistema".
    // Tenia razon y el arreglo anterior no lo cubria. load() ya descartaba del conjunto
    // candidato los productos que estan en el carrito, pero eso solo quita ESE producto:
    // la tabla de prioridad seguia pidiendo 'pantalla' y le entregaba el SIGUIENTE
    // protector. Al anclar el Hidrogel HD el efecto se veia enseguida: agregarlo hacia
    // aparecer el Matte en su lugar.
    // Las categorias que ya viajan en el carrito llegan aqui desde load() y entran al
    // registro ANTES de elegir nada. La funda sigue siendo la excepcion.
    if(catsCarrito){ for(var k in catsCarrito){ if(k!=='funda') catUsada[k]=1 } }
    // 2026-08-19 · UNA CATEGORIA NO SE REPITE, SALVO FUNDA. Sebastian: "si se agrega un
    // protector de pantalla, que no vuelva a recomendar otro protector, sino las otras
    // categorias. Igual con el protector de camara. Si agrega una funda de esa seccion,
    // si puede recomendar otras fundas".
    // EL FALLO QUE ARREGLA: los anclados y el relleno final no marcaban la categoria, solo
    // el nodo. Al anclar un protector de pantalla, la tabla de prioridad volvia a buscar
    // 'pantalla' y metia el segundo protector en el siguiente puesto: dos pantallas y fuera
    // el trasero. La tabla por si sola nunca repetia -recorre cada categoria una vez-, asi
    // que el duplicado solo podia entrar por esos dos caminos.
    // LA FUNDA ES LA EXCEPCION Y NO ES un descuido: es la palanca de ticket promedio -260
    // de 859 pedidos ya se llevan dos-, asi que ofrecer una segunda funda es el objetivo,
    // no una repeticion.
    function marca(n){
      var c=n.getAttribute('data-cat')||'otro';
      if(c!=='funda') catUsada[c]=1;
    }
    // Productos fijos del editor primero, y solo si estan disponibles para ese modelo.
    ANCLADOS.forEach(function(id){
      if(out.length>=MAX) return;
      for(var i=0;i<arr.length;i++){
        if(used[i]) continue;
        if(arr[i].getAttribute('data-pid')===id){ out.push(arr[i]); used[i]=1; marca(arr[i]); return; }
      }
    });
    rank.forEach(function(cat){
      if(out.length>=MAX) return;
      if(catUsada[cat]) return;
      for(var i=0;i<arr.length;i++){
        if(used[i]) continue;
        if((arr[i].getAttribute('data-cat')||'otro')===cat){ out.push(arr[i]); used[i]=1; marca(arr[i]); return; }
      }
    });
    for(var i=0;i<arr.length && out.length<MAX;i++){
      if(used[i]) continue;
      if(catUsada[arr[i].getAttribute('data-cat')||'otro']) continue;
      out.push(arr[i]); used[i]=1; marca(arr[i]);
    }
    return out;
  }
  // 2026-07-30 · SEGUNDO NIVEL. Recibe TODAS las tarjetas que devolvio el endpoint y
  // las tres que ya se pintaron arriba, y arma el carril con lo que sobra.
  // No re-crea las tarjetas desde cero: las LEE y las resume, asi que el precio que
  // muestra es el mismo precio de variante que calculo el Liquid. Una sola fuente.
  // El resaltado naranja de "esto cierra el envio gratis" se queda en las tres de
  // arriba a proposito: envInsignias solo recorre #mccombo-list. Marcar tambien las
  // de aqui repartiria la atencion entre siete tarjetas y ninguna destacaria.
  // Cuando se agrega una, el formulario recarga la pagina, el carrito sube y la barra
  // se recalcula sola al volver a leer /cart.js. Ahi esta la sumatoria.
  function extras(todas,elegidas,cur){
    var box=document.getElementById('mccombo-extra');
    var rail=document.getElementById('mccombo-extra-list');
    if(!box||!rail) return;
    var usados={};
    elegidas.forEach(function(n){ usados[n.getAttribute('data-pid')]=1 });
    // 2026-07-30 · POR RONDAS, NO POR SOBRANTES. Sebastian: "la idea es que podamos
    // agregar mas protectores de pantalla, el otro protector de camara, mas traseros y
    // mas fundas... pero que sea estrategico, que la atencion no se diluya".
    // Antes esto tomaba las primeras seis tarjetas que sobraran, y como la coleccion
    // llega agrupada, salian seis fundas seguidas: mucha opcion y ninguna variedad.
    // Ahora reparte POR RONDAS siguiendo la misma tabla de prioridad de arriba: primero
    // el segundo de pantalla, el segundo de camara, el segundo de trasero y el segundo
    // de funda; luego el tercero de cada uno, y asi. Con seis tarjetas eso da cobertura
    // completa de las cuatro categorias y todavia sobra sitio para la mas vendida.
    // Los cat:accesorio se descartan igual que arriba: no completan la compra.
    var libres=todas.filter(function(n){
      return !usados[n.getAttribute('data-pid')] && (n.getAttribute('data-cat')||'otro')!=='accesorio';
    });
    // 2026-08-19 · UN VIDRIO ANTES QUE OTRO HIDROGEL. Sebastian: "no esta recomendando
    // el primero vidrio, sigue recomendando hidrogel matte, cuando arriba ya se esta
    // recomendando el hidrogel HD". Vidrio e hidrogel son la MISMA categoria, cat:pantalla,
    // y eso se decidio a proposito: no todos los modelos tienen vidrio, asi que separarlos
    // en dos categorias dejaria huecos. Como la categoria no alcanza para distinguirlos,
    // se mira el NOMBRE de la tarjeta, que es el unico dato que ya viaja en el DOM. Esto
    // no cambia que categoria entra ni cuantas: solo decide CUAL dentro de la categoria.
    function familia(n){
      var t=n.querySelector('.mccombo__t');
      var s=((t?t.textContent:'')||'').toLowerCase();
      if(s.indexOf('vidrio')>=0) return 'vidrio';
      if(s.indexOf('hidrogel')>=0) return 'hidrogel';
      return '';
    }
    var famUsada={};
    elegidas.forEach(function(n){ var f0=familia(n); if(f0) famUsada[f0]=1 });
    var rank=PRIO[cur]||PRIO.otro||PRIO_DEF.otro;
    var resto=[], tomado={}, ronda=0;
    while(resto.length<EXTRA_MAX && ronda<8){
      var movio=false;
      for(var r=0;r<rank.length && resto.length<EXTRA_MAX;r++){
        // Dos pasadas. En la primera solo entran las familias que no han salido todavia;
        // en la segunda ya vale cualquiera, para no dejar la ronda vacia.
        var idx=-1;
        for(var pase=0;pase<2 && idx<0;pase++){
          for(var i=0;i<libres.length;i++){
            if(tomado[i]) continue;
            if((libres[i].getAttribute('data-cat')||'otro')!==rank[r]) continue;
            var f1=familia(libres[i]);
            if(pase===0 && f1 && famUsada[f1]) continue;
            idx=i; break;
          }
        }
        if(idx<0) continue;
        var f2=familia(libres[idx]); if(f2) famUsada[f2]=1;
        resto.push(libres[idx]); tomado[idx]=1; movio=true;
      }
      if(!movio) break;
      ronda++;
    }
    // Relleno final por si alguna categoria no estaba en la tabla.
    for(var j=0;j<libres.length && resto.length<EXTRA_MAX;j++){ if(!tomado[j]){ resto.push(libres[j]); tomado[j]=1 } }
    rail.textContent='';
    if(!resto.length){ box.hidden=true; return }
    resto.forEach(function(n){
      var img=n.querySelector('.mccombo__img img');
      var tit=n.querySelector('.mccombo__t');
      var pre=n.querySelector('.mccombo__p');
      var inp=n.querySelector('.mccombo__f input[name="id"]');
      var url=tit?(tit.getAttribute('href')||'#'):'#';
      var nombre=tit?(tit.textContent||'').trim():'';
      var it=document.createElement('div');
      it.className='mcx__it';
      it.setAttribute('data-pid',n.getAttribute('data-pid')||'');
      var a=document.createElement('a');
      a.className='mcx__lk'; a.href=url; a.target='_blank'; a.rel='noopener';
      if(img&&img.getAttribute('src')){
        var im=document.createElement('img');
        im.src=img.getAttribute('src'); im.alt=img.getAttribute('alt')||nombre;
        im.loading='lazy'; im.width=52; im.height=52;
        a.appendChild(im);
      }
      var tx=document.createElement('span'); tx.className='mcx__t'; tx.textContent=nombre;
      a.appendChild(tx);
      it.appendChild(a);
      // 2026-07-30 · PRECIO Y BOTON EN LA MISMA FILA. Sebastian: "hay mucho espacio a
      // la derecha del precio, que podria ser utilizable". Ese hueco era el sitio del
      // boton. Al juntarlos, la tarjeta pierde una fila entera de alto, en el carril
      // caben mas tarjetas visibles y el precio queda pegado a la accion que lo cobra.
      // La fila hace wrap si no cabe, asi que en pantallas muy angostas el boton baja
      // solo en vez de desbordarse.
      var pie=document.createElement('div'); pie.className='mcx__pie';
      var pr=document.createElement('span'); pr.className='mcx__p';
      pr.textContent=pre?(pre.textContent||'').trim():'';
      pie.appendChild(pr);
      it.appendChild(pie);
      if(inp&&inp.value){
        var f=document.createElement('form');
        f.method='post'; f.action='/cart/add'; f.className='mcx__f';
        var i1=document.createElement('input'); i1.type='hidden'; i1.name='id'; i1.value=inp.value; f.appendChild(i1);
        var i2=document.createElement('input'); i2.type='hidden'; i2.name='quantity'; i2.value='1'; f.appendChild(i2);
        var b=document.createElement('button'); b.type='submit'; b.className='mcx__add';
        b.textContent=EXTRA_BOTON;
        b.setAttribute('aria-label',EXTRA_BOTON+(nombre?(' '+nombre):''));
        f.appendChild(b); pie.appendChild(f);
      } else {
        var av=document.createElement('a');
        av.className='mcx__add mcx__add--link'; av.href=url; av.target='_blank'; av.rel='noopener';
        av.textContent=EXTRA_VER;
        pie.appendChild(av);
      }
      rail.appendChild(it);
    });
    box.hidden=false;
  }

  function load(name,handle,forzar){
    if(!handle||(!forzar&&handle===currentHandle)) return;
    currentHandle=handle; currentName=name;
    // 2026-07-30 · ORDENADO POR MAS VENDIDO. Sebastian: "en 'protege la parte de atras'
    // esta saliendo el hidrogel trasero CON DISENO y seria mejor el transparente".
    // La causa era el orden: sin sort_by, la coleccion llega en el orden interno de
    // Shopify y pick() se queda con el primero de cada categoria, que puede ser
    // cualquiera. Pidiendo best-selling, el primero de cada categoria es el que MAS SE
    // VENDE, que es tambien la recomendacion mas defendible. Si aun asi quiere forzar
    // uno concreto, el ajuste "Productos fijos" (anclados) lo pone de primero.
    /* 2026-08-20 · LA VISTA PREVIA TIENE QUE PODER PROBARSE. La pagina se sirve del tema
       que estas viendo, pero esta llamada no lo decia, asi que en una vista previa iba a
       buscar los productos al tema PUBLICADO. Resultado: cualquier cambio de esta seccion
       era imposible de verificar sin publicarlo antes. Shopify expone que tema esta
       sirviendo la pagina; si es uno sin publicar, se lo pasamos a la llamada. En la
       tienda normal el rol es 'main' y esto no anade nada. */
    var previa = '';
    try {
      if (window.Shopify && Shopify.theme && Shopify.theme.id &&
          String(Shopify.theme.role || '').toLowerCase() !== 'main') {
        previa = '&preview_theme_id=' + Shopify.theme.id;
      }
    } catch (e) {}
    /* MIcase 2026-08-20 · LA RUTA LA DECIDE EL DICCIONARIO, NO ESTE ARCHIVO.
       El nombre del desplegable no siempre es una etiqueta con productos detras
       ("Redmi Note 10 / 10s" la lleva 1 producto; "Redmi Note 10", 13). El desvio
       vive en el metaobjeto micase_modelo y lo publica snippets/micase-modelo.liquid.
       Si no cargara, rutaDe devuelve lo mismo que le dan y esto se comporta como antes. */
    var mcRuta = (window.MCModelo && MCModelo.rutaDe) ? MCModelo.rutaDe(handle) : handle;
    fetch('/collections/all/'+mcRuta+'?sort_by=best-selling&section_id='+sid+previa)
      .then(function(r){return r.text()})
      .then(function(html){
        // 2026-07-30 · SE PUBLICA LA RESPUESTA PARA NO PEDIRLA DOS VECES.
        // micase-similares necesitaba exactamente este mismo HTML y lo pedia por su
        // cuenta: dos peticiones identicas al cargar y dos mas por cada cambio de
        // modelo. Ahora se deja aqui, con el handle al que corresponde, y se avisa
        // por evento. Se comparte el TEXTO, no los nodos: mas abajo este metodo
        // mueve las tarjetas fuera de 'items', asi que compartir el DOM vivo le
        // entregaria a similares un contenedor ya vaciado.
        try{
          window.__mcComboItems={handle:handle,html:html};
          document.dispatchEvent(new CustomEvent('micase:combo-items',{detail:{handle:handle,html:html}}));
        }catch(e){ console.warn('[MIcase] micase-combo: no se pudo publicar el evento micase:combo-items con las tarjetas del combo', e); }
        var d=document.createElement('div'); d.innerHTML=html;
        var items=d.querySelector('#mccombo-items');
        var list=document.getElementById('mccombo-list');
        if(!items){ el.hidden=true; return; }
        var mine=items.querySelector('[data-pid="'+pid+'"]'); if(mine) mine.remove();
        if(!items.children.length){ el.hidden=true; return; }
        /* La categoria de lo que ya esta en el carrito. /cart.js no trae las etiquetas del
           producto (regla 81), pero estas tarjetas si traen data-cat, asi que se resuelve
           cruzando por product_id contra envCartPids. Se calcula ANTES de filtrar, porque
           el filtro de abajo es justamente el que saca del conjunto lo que ya se llevo. */
        var catsCarrito={};
        Array.prototype.slice.call(items.children).forEach(function(n){
          if(!envCartPids[String(n.getAttribute('data-pid')||'')]) return;
          catsCarrito[n.getAttribute('data-cat')||'otro']=1;
        });
        /* Una recomendacion por modelo solo es valida si Liquid encontro una variante
           disponible y genero su formulario. Antes las tarjetas sin coincidencia se
           conservaban y terminaban mostrando "Ver": obligaban a salir del flujo y
           podian llevar a una referencia incompatible. */
        var arr=Array.prototype.slice.call(items.children).filter(function(n){
          var disponible=!!n.querySelector('.mccombo__f input[name="id"]');
          var yaEsta=!!envCartPids[String(n.getAttribute('data-pid')||'')];
          return disponible&&!yaEsta;
        });
        if(!arr.length){ el.hidden=true; return; }
        var chosen=pick(arr, el.getAttribute('data-curcat')||'otro', catsCarrito);
        if(!chosen.length){ el.hidden=true; return; }
        document.getElementById('mccombo-model').textContent=name;
        document.getElementById('mccombo-prep').textContent=(mode==='variant')?PREP_PARA:PREP_TU;
        list.innerHTML='';
        chosen.forEach(function(n){
          var sp=n.querySelector('.mccombo__cat');
          if(sp){ var t=LBL[n.getAttribute('data-cat')||'otro']||LBL_OTRO; if(t) sp.textContent=t; }
          list.appendChild(n);
        });
        extras(arr,chosen,el.getAttribute('data-curcat')||'otro');
        el.hidden=false;
        envPinta();
      }).catch(function(e){ console.warn('[MIcase] micase-combo: fallo al pedir a la coleccion las tarjetas de los productos del combo', e); });
  }
  // 2026-07-28 · LA VARIANTE MANDA. Antes, con modelo del quiz se hacia load() y RETURN,
  // asi que el listener de variante nunca se registraba y el titulo se quedaba pegado en
  // el modelo del quiz aunque la persona cambiara de modelo. El quiz pasa a ser respaldo.
  // La preposicion sigue siendo "de tu" cuando la eleccion es explicita (coincide con lo
  // guardado, que micase-fixes mantiene al dia) y "para" cuando es la variante por defecto.
  var saved=null; try{saved=JSON.parse(localStorage.getItem('micase_modelo')||'null')}catch(e){ console.warn('[MIcase] micase-combo: no se pudo leer el JSON del modelo guardado en localStorage', e); }
  function modoDe(val){ return (saved&&saved.n&&val&&mchandle(saved.n)===mchandle(val))?'quiz':'variant'; }
  var pj=document.querySelector('[data-product-json]');
  var p=null; try{ p=pj?JSON.parse(pj.textContent):null }catch(e){ console.warn('[MIcase] micase-combo: no se pudo leer el JSON del producto de [data-product-json]', e); }
  var idx=p?mcopt(p):-1;
  var optName=(idx>=0&&p)?p.options[idx]:null;
  var v0=optName?mccur(p,idx,optName):null;
  if(v0){ mode=modoDe(v0); load(v0,mchandle(v0)); }
  else if(saved&&saved.h&&saved.n){ mode='quiz'; load(saved.n,saved.h); }
  if(optName){ document.addEventListener('change',function(e){var t=e.target;if(t&&t.tagName==='INPUT'&&t.type==='radio'&&t.name===optName){mode=modoDe(t.value);load(t.value,mchandle(t.value))}},true); }
  /* 2026-08-01 · AVISO COMUN DE "EL CARRITO CAMBIO".
     El boton principal de compra es del tema (assets/main-product.js) y agrega por AJAX
     sin avisarle a nuestras secciones, asi que los indicadores de envio gratis se
     quedaban con el subtotal de antes. Este ayudante escucha por dos vias y avisa una
     sola vez, con el carrito ya leido:
       1) el bus del propio tema (subscribe / PUB_SUB_EVENTS.cartUpdate de assets/utils.js);
       2) como respaldo, el contador .cart-count de la cabecera y el bloque #minicart-form,
          que el tema reescribe SIEMPRE que el carrito cambia, venga el cambio de donde
          venga. Con MutationObserver, sin setInterval.
     Se define una sola vez aunque el fragmento este repetido en varios archivos. */
  window.MCcarrito = window.MCcarrito || (function(){
    var subs=[], t=null, listo=false;
    function reparte(c){ for(var i=0;i<subs.length;i++){ try{ subs[i](c) }catch(e){ console.warn('[MIcase] micase-combo: fallo un suscriptor de MCcarrito al recibir el carrito', e); } } }
    function lee(){
      fetch('/cart.js',{credentials:'same-origin',headers:{'Accept':'application/json'}})
        .then(function(r){ if(!r.ok) throw 0; return r.json() })
        .then(reparte)
        .catch(function(){ reparte(null) });
    }
    function avisa(){ clearTimeout(t); t=setTimeout(lee,300); }
    function mira(n,cfg){ if(n){ try{ new MutationObserver(avisa).observe(n,cfg) }catch(e){ console.warn('[MIcase] micase-combo: no se pudo observar el nodo del carrito con MutationObserver', e); } } }
    function arranca(){
      if(listo) return; listo=true;
      try{
        if(typeof subscribe==='function' && typeof PUB_SUB_EVENTS!=='undefined' && PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate){
          subscribe(PUB_SUB_EVENTS.cartUpdate, avisa);
        }
      }catch(e){ console.warn('[MIcase] micase-combo: no se pudo suscribir al evento cartUpdate del tema', e); }
      if(typeof MutationObserver!=='function') return;
      var cc=document.querySelectorAll('.cart-count');
      for(var i=0;i<cc.length;i++){ mira(cc[i].parentNode||cc[i],{childList:true,characterData:true,subtree:true}) }
      mira(document.getElementById('minicart-form'),{childList:true});
      // Volver atras con el carrito ya cambiado (bfcache) tampoco puede dejar cifras viejas.
      window.addEventListener('pageshow',function(e){ if(e.persisted) avisa() });
    }
    if(document.readyState=='loading') document.addEventListener('DOMContentLoaded',arranca);
    else arranca();
    return { on:function(f){ if(typeof f==='function') subs.push(f) }, avisa:avisa };
  })();
  // Se relee /cart.js al cargar y despues de cada agregado desde el combo: por el submit
  // del formulario y, como respaldo, ~800 ms despues del clic (el tema intercepta el
  // submit para abrir el drawer, asi que el evento puede no llegar completo).
  if(ENV_ON){
    envLee();
    var envCta=document.getElementById('mccombo-cta');
    if(envCta) envCta.addEventListener('click',function(e){ e.preventDefault(); envAgrega() });
    document.addEventListener('submit',function(e){
      var t=e.target;
      if(t&&t.classList&&t.classList.contains('mccombo__f')) setTimeout(envLee,800);
    },true);
    el.addEventListener('click',function(e){
      var t=e.target;
      while(t&&t!==el){
        if(t.tagName==='BUTTON'&&t.classList&&t.classList.contains('mccombo__add')){ setTimeout(envLee,800); return }
        t=t.parentNode;
      }
    },true);
    // 2026-08-01 · EL BOTON DE COMPRA DEL TEMA TAMBIEN MUEVE EL CARRITO.
    // Los tres avisos de arriba solo cubren lo que se agrega DESDE ESTA SECCION. El
    // "Anadir al carrito" principal es del tema y no pasa por aqui: el medidor se
    // quedaba con el subtotal anterior. Ahora se repinta con el carrito recien leido
    // por MCcarrito, sin pedir /cart.js una segunda vez.
    if(window.MCcarrito) window.MCcarrito.on(function(c){
      if(c && typeof c.items_subtotal_price === 'number'){
        var cambio=envCarritoIds(c);
        envSub=c.items_subtotal_price;
        if(cambio&&currentHandle&&!el.hidden){ load(currentName,currentHandle,true) }
        else { envPinta() }
      }
      else { envLee(); }
    });
  }
})();